import React from 'react';
import Loading from 'react-fullscreen-loading';

const LoadingSpinner = () => {
    return (
        <Loading loading background="#7882a45f" loaderColor="#F1D00A" />
    );
};

export default LoadingSpinner;